import axios from "axios";

export const performRequest = async (
  method,
  url,
  data = null,
  responseType = "json",
) => {
  try {
    const config = {
      method: method,
      url: url,
      ...(data && { data: data }),
      responseType: responseType,
    };

    const response = await axios(config);

    if (response.status === 200 || response.status === 201) {
      if (responseType === "blob") {
        return {
          success: true,
          data: response.data,
          error: "",
        };
      } else {
        const successData = response.data;
        const resCode = successData.errorCode || successData.errCode || null;
        const resMsg = successData.errorMessage || successData.errMsg || null;
        return {
          success: successData.success,
          data: successData.data,
          errorCode: resCode,
          errCode: resCode, // 호환성을 위해 추가
          errorMessage: resMsg,
          errMsg: resMsg, // 호환성을 위해 추가
          error: "",
        };
      }
    } else {
      return {
        success: false,
        error: response.data.data,
      };
    }
  } catch (err) {
    console.log("[performRequest] catch 블록 진입");
    console.log("[performRequest] 전체 에러:", err);

    if (
      err.response &&
      err.response.data instanceof Blob &&
      err.response.data.type === "application/json"
    ) {
      try {
        const text = await err.response.data.text();
        console.log("[performRequest] Blob 응답 원본:", text);
        const json = JSON.parse(text);
        console.log("[performRequest] 파싱된 JSON:", json);

        return {
          success: false,
          errCode: json.errCode || json.errorCode,
          errMsg:
            json.errMsg ||
            json.errorMessage ||
            json.message ||
            json.error?.errMsg ||
            "알 수 없는 오류 발생",
          error:
            json.error ||
            json.errorMessage ||
            json.errMsg ||
            json.message ||
            "알 수 없는 오류 발생",
        };
      } catch (parseErr) {
        return {
          success: false,
          errCode: null,
          errMsg: "에러 응답 파싱 실패",
          error: "에러 응답 파싱 실패",
        };
      }
    }

    const errorData = err.response?.data;
    const finalErrCode = errorData?.errCode || errorData?.errorCode || null;
    const finalErrMsg = errorData?.errMsg || errorData?.errorMessage || errorData?.message || err.message || "요청 중 알 수 없는 오류 발생";

    return {
      success: false,
      errCode: finalErrCode,
      errorCode: finalErrCode, // 호환성을 위해 추가
      errMsg: finalErrMsg,
      errorMessage: finalErrMsg, // 호환성을 위해 추가
      error: finalErrMsg,
    };
  }
};
